<template>
	<div class="email">
		<div v-if="!isVerified">
			<div :class="[isMobile ? 'd_block' : 'd_flex', 'mb_10']">
				<input
					:class="[isMobile ? '' : 'mr_10']"
					type="text"
					:placeholder="$t('merchant.security.placeholder')"
					readonly
					:value="member_info?.email_address"
				/>
				<!-- <button
				v-if="!token"
				class="button_bg_blue"
				@click="sendVerificationCode"
			>
				{{ $t('button.code') }}
			</button> -->
				<button
					:class="['button_bg_blue', isMobile ? 'w100 mt_10' : '']"
					@click="sendVerificationCode"
				>
					{{ $t('button.code') }}
				</button>
			</div>
			<div v-if="token">
				<div
					:class="[isMobile ? 'd_block' : 'd_flex', 'timer_input_box', 'mb_10']"
				>
					<div class="d_flex timer_input">
						<input
							type="text"
							v-model="auth_code"
							:placeholder="$t('merchant.security.placeholder1')"
							class="auth_code_input"
						/>
						<div class="timer">{{ time }}</div>
					</div>
					<div v-if="isMobile" class="mb_15 mt_10">
						<span class="fc_red_border" @click="sendVerificationCode">{{
							$t('merchant.email.link1')
						}}</span>
					</div>
					<button
						:class="['button_primary', isMobile ? 'w100' : '']"
						@click="checkVerificationCode"
					>
						{{ $t('button.code_check') }}
					</button>
				</div>
				<div v-if="!isMobile" class="mb_15">
					<span class="fc_red_border" @click="sendVerificationCode">{{
						$t('merchant.email.link1')
					}}</span>
				</div>
				<!-- <button class="button_bg_red mb_30" @click="checkVerificationCode">
				{{ $t('button.code_check') }}
			</button> -->
				<!-- <button class="button_bg_black mb_60">
				{{ $t('button.code_completed') }}
			</button> -->
			</div>
		</div>

		<div v-if="isVerified" class="verification-success mt_20">
			<div class="success-icon text-center mb_10">
				<img
					v-if="!isMobile"
					src="@/assets/images/v2/img-email-complete.png"
					alt="인증 완료"
				/>
				<img
					v-if="isMobile"
					src="@/assets/images/v2/img-email-complete-m.png"
					alt="인증 완료"
				/>
			</div>
		</div>
		<!-- <div class="limit gray_back">
			<p class="mb_20">{{ $t('merchant.security.title3') }}</p>
			<ul>
				<li>- {{ $t('merchant.security.text1') }}</li>
				<li>- {{ $t('merchant.security.text2') }}</li>
				<li>- {{ $t('merchant.security.text3') }}</li>
				<li>- {{ $t('merchant.security.text4') }}</li>
			</ul>
		</div> -->

		<!-- <div v-if="!mobile">
			<div v-if="!token">
				<input
					type="email"
					:placeholder="$t('input.placeholder.email')"
					:value="member_info.email_address"
					disabled
				/>
				<button class="button_bg_red mt_10" @click="sendVerificationCode">
					{{ $t('button.code') }}
				</button>
			</div>

			<div v-if="token" class="mt_20">
				<div class="d_flex">
					<div class="timer">{{ time }}</div>
					<input
						type="text"
						:placeholder="$t('input.placeholder.code_request')"
						style="border-radius: 0 5px 5px 0"
					/>
				</div>
				<div class="link_code_send">
					<a class="fc_red" @click="sendVerificationCode">{{
						$t('merchant.email.link1')
					}}</a>
				</div>
				<button class="button_bg_red" @click="checkVerificationCode">
					{{ $t('button.code_check') }}
				</button>
			</div>
		</div>
		<div v-else class="mobile">
			<div v-if="!token">
				<input
					type="email"
					:placeholder="$t('input.placeholder.email')"
					:value="member_info.email_address"
					disabled
				/>
				<button class="button_bg_red w100 mt_10" @click="sendVerificationCode">
					{{ $t('button.code') }}
				</button>
			</div>
			<div v-if="token" class="mt_20">
				<div class="base">
					<span class="mobile_timer">{{ time }}</span>
					<input
						type="text"
						:placeholder="$t('input.placeholder.code_request')"
					/>
				</div>
				<div class="link_code_send">
					<a class="resend" @click="sendVerificationCode">{{
						$t('merchant.email.link1')
					}}</a>
				</div>
				<button class="button_bg_red" @click="checkVerificationCode">
					{{ $t('button.code_check') }}
				</button>
			</div>
		</div> -->
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { createVerification, createVerificationToken } from '@/api/mail';
import { commonError } from '@/common/dialog';

export default {
	name: 'Email',
	data() {
		return {
			token: null,
			timer: null,
			auth_code: '',
			time: '05:00',
			time_remaining: 0,
			mobile: window.innerWidth <= 768,
			isVerified: false,
		};
	},
	computed: {
		...mapGetters('auth', ['member_info']),
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		async sendVerificationCode() {
			const { token } = await createVerificationToken().catch(commonError);
			this.token = token;
			this.startTimer();
		},
		async checkVerificationCode() {
			try {
				await createVerification({
					token: this.token,
					auth_code: this.auth_code,
				});
				this.resetTimer();
				this.isVerified = true;
				await this.$store.dispatch('auth/getMemberInfo');
			} catch (error) {
				commonError(error);
			}
		},
		startTimer() {
			clearInterval(this.timer);
			this.time_remaining = 300;
			this.timer = setInterval(() => {
				this.updateTimer();
			}, 1000);
		},
		resetTimer() {
			clearInterval(this.timer);
			this.token = null;
			this.time = '05:00';
			this.auth_code = '';
		},
		updateTimer() {
			if (this.time_remaining === 0) return this.resetTimer();
			this.time_remaining--;
			const minute = '0' + Math.floor(this.time_remaining / 60);
			const seconds =
				this.time_remaining % 60 < 10
					? '0' + (this.time_remaining % 60)
					: this.time_remaining % 60;
			this.time = minute + ':' + seconds;
		},
	},
};
</script>
<style>
.rtr_mypage-certification .display_status {
	display: inline-block;
	padding: 10px 15px;
	min-width: 89px;
	font-size: 14px;
	color: #ccc;
	background-color: #fff;
	border: 1px solid #ddd;
	border-radius: 10px;
	pointer-events: none;
}
.rtr_mypage-certification .completed {
	color: #333;
	border-color: #333;
}
/* .rtr_mypage-certification .security_email .level_3 .icon {
	width: 31px;
	height: 17px;
	background-image: url('~@/assets/images/icon/otp.png');
	background-repeat: no-repeat;
}
.rtr_mypage-certification .security_email .level_4 .icon {
	height: 25px;
	width: 25px;
	background-image: url('~@/assets/images/icon/accout_security.png');
}
.rtr_mypage-certification .security_email .level_4 .circle_url {
	background: url('~@/assets/images/icon/four_gray.png');
	background-size: cover;
}
.level_4.on .rtr_mypage-certification .security_email .level_4 .icon {
	background-image: url('~@/assets/images/icon/accout_security_red.png') !important;
} */
.fc_red_border {
	position: relative;
	color: #ff4848;
	font-size: 14px;
}
.fc_red_border:before {
	content: '';
	position: absolute;
	bottom: -3px;
	left: 0;
	width: 100%;
	height: 1px;
	background-color: #ff4848;
}

.timer_input {
	position: relative;
}

.auth_code_input {
	border-radius: 8px 0px 0px 8px !important;
	border-right: 0 !important;
	border: 1px solid #f0f0f0;
	transition: border-color 0.3s ease;
}

.timer {
	border: 1px solid #f0f0f0;
	border-left: 0;
	border-radius: 0px 8px 8px 0px;
	transition: border-color 0.3s ease;
}

.timer_input:focus-within .auth_code_input,
.timer_input:focus-within .timer {
	border-color: #2a5cda;
}
</style>
